module.exports = __webpack_public_path__ + "static/media/IMG_0718_Reduced.ae90c6ce.jpg";